import { useTranslation } from 'react-i18next';
import { CommonModal } from '@/components/Modal/CommonModal';
import React, { useCallback, useMemo, useState } from 'react';
import Checkbox from 'antd/es/checkbox';
import cx from 'clsx';
import styles from './index.module.scss';
import { useGetClaimCode } from '../../hooks';
import { Button } from '@/components';
import { CopyImage } from '@/components/shared';
import { useOfficialAccount, useOfficialFollow } from '@/hooks';
import { OfficialBadge } from '../../types';
import { openNewWindow } from '@/utils';

export const ClaimCodeModal = ({
  on,
  turnOff,
  data,
  token,
  claimCode,
}: {
  on: boolean;
  turnOff: () => void;
  data: OfficialBadge;
  token?: string;
  claimCode?: string;
}) => {
  const { t } = useTranslation();

  const { officialAccountDetail } = useOfficialAccount(data?.official_id);
  const { mutateAsync: getClaimCode, isLoading: isGettingCode } = useGetClaimCode(data.id);
  const { mutate: followOfficial } = useOfficialFollow(data?.official_id);
  const [selectFollow, setSelectFollow] = useState(true);

  const showFollowCheckBox = useMemo(
    () => !claimCode && officialAccountDetail && !officialAccountDetail?.is_following,
    [claimCode, officialAccountDetail],
  );

  const handleCheckBox = useCallback(e => {
    setSelectFollow(e.target.checked);
  }, []);

  const handleClickClaim = useCallback(async () => {
    const res = await getClaimCode(token);

    if (!officialAccountDetail?.is_following && res.code) {
      followOfficial({ isFollowing: false });
    }
  }, [followOfficial, getClaimCode, officialAccountDetail?.is_following, token]);

  return (
    <CommonModal containerClassName={styles.modalContainer} on={on} turnOff={turnOff}>
      <div className={styles.title}>{t('ClaimCodeModal.1udxj6y')}</div>
      <div className={styles.mintLink} onClick={() => openNewWindow(data?.mint_url, '_blank')}>
        {data?.mint_url}
      </div>
      <div className={styles.mintDesc}>{data?.mint_desc}</div>
      <div className={styles.claimCodeContainer}>
        <div className={cx(styles.claimCodeInner, claimCode && styles.showCode)}>
          {claimCode ? (
            <div className={styles.claimCode}>
              <span className={styles.code}>{claimCode.split('').join(' ')}</span>
              <CopyImage value={claimCode} size={28} />
            </div>
          ) : (
            <Button
              type="primary"
              className={styles.btn}
              onClick={() => handleClickClaim()}
              loading={isGettingCode}
              disabled={!selectFollow}>
              {t('ClaimCodeModal.8bukl7')}
            </Button>
          )}
        </div>
      </div>
      {showFollowCheckBox && (
        <div className={styles.checkBoxContainer}>
          <Checkbox checked={selectFollow} onChange={handleCheckBox} />
          <div className={styles.label}>
            {t('ClaimCodeModal.yw5yvl')}
            {officialAccountDetail.name}
            {t('ClaimCodeModal.l2nshk')}
          </div>
        </div>
      )}
    </CommonModal>
  );
};
